/*
 * Copyright (c) 2016-present, Parse, LLC
 * All rights reserved.
 *
 * This source code is licensed under the license found in the LICENSE file in
 * the root directory of this source tree.
 */
import PropTypes from 'prop-types';
import React     from 'react';
import Icon      from 'components/Icon/Icon.react';
import styles    from 'components/SegmentSelect/SegmentSelect.scss';

export default class SegmentSelect extends React.Component {
  constructor() {
    super();
    this.state = {
      fto: true
    };
  }

  handleClick(v) {
    if (this.props.current !== v) {
      this.props.onChange(v)
    }

    this.setState({ fto: false })
  }

  render() {
    let labels = this.props.labels;
    let values = this.props.values;

    let buttons = [];

    for (let v in values) {
      buttons.push(
        <div
          key={values[v]}
          className={values[v].toLowerCase() === this.props.current.toLowerCase() ? styles.current : null}
          onClick={this.handleClick.bind(this, values[v])} >
          {this.props.icons
            ?
              values[v] === this.props.current
                ?
                  <Icon width={48} height={48} name={'icon-logo-' + values[v].toLowerCase()} colored={true} />
                :
                  <Icon width={48} height={48} name={'icon-logo-' + values[v].toLowerCase() + '-disabled'} colored={true} />
            : null
          }
          {labels ? labels[v] : values[v]}
        </div>
      );
    }

    return (
      <div className={[styles.row, this.props.icons ? styles.icons: null].join(' ')}>
        {buttons}
      </div>
    );
  }
}

SegmentSelect.propTypes = {
  icons: PropTypes.bool,
  labels: PropTypes.arrayOf(PropTypes.string),
  values: PropTypes.arrayOf(PropTypes.string).isRequired,
  current: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};
